import './style/index.css';

import { MsalProvider } from '@azure/msal-react';
import Clarity from '@microsoft/clarity';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { msalInstance } from './MsalConfig';

if (import.meta.env.VITE_ENVIRONMENT === 'prod') {
  Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID || '');
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
